import { Action, ActionType, IAuthFail, IAuthSuccess, IAuthSuccessResponse } from "@redux/actionTypes/authActionTypes";
import rootReducer from "@redux/reducers";
import { RootState } from "@redux/store/store";
import { Dispatch } from "redux";
import { AxiosReq } from "../../services/axios";
import { APIResponseType } from "./actionResultTypes";

export const AuthStart =
  (payload: any, cb: (arg: IAuthSuccessResponse) => void): any =>
  async (dispatch: Dispatch<Action>) => {
    try {
      const result = (await AxiosReq.post("/api/Account/Login", payload)) as any;
      if (result) {
        const isAccessToken = result._object.userToken ? true : false;
        const payloadData = { ...result, authStatus: isAccessToken, user: result._object };
        dispatch<IAuthSuccess>({ type: ActionType.AUTH_SUCCESS, payload: payloadData });
        cb(result);
      }
    } catch (error: any) {
      cb(error);
      dispatch<IAuthFail>({ type: ActionType.AUTH_FAIL, payload: null });
    }
  };

export const AuthLogout = (): any => async (dispatch: Dispatch<Action>, getState: () => RootState) => {
  try {
    const {
      auth: { accessToken },
    } = getState();
    const result = await AxiosReq.post(`/api/Account/logout`, {}, accessToken);
    dispatch({ type: ActionType.DO_LOGOUT });
    dispatch({ type: ActionType.RESET_REDUX_STATE });
  } catch (error) {}
};

export const ForgotPassword =
  (payload: any, cb: (arg: any) => void): any =>
  async (dispatch: Dispatch<Action>, getState: typeof rootReducer) => {
    try {
      const {
        auth: { user },
      } = getState();
      const result = (await AxiosReq.post(`/api/Account/ForgotPassword`, payload, user.userToken)) as any;
      cb(result);
    } catch (error: any) {
      cb(error);
    }
  };

export const ResetUserPassword =
  (payload: any, cb: (arg: any) => void): any =>
  async (dispatch: Dispatch<Action>, getState: typeof rootReducer) => {
    try {
      const {
        auth: { user },
      } = getState();
      const result = (await AxiosReq.post(`/api/Account/ResetPassword`, payload, user.userToken)) as any;
      cb(result);
    } catch (error: any) {
      cb(error);
    }
  };

export const CheckResetPassToken =
  (token: any, cb: (arg: APIResponseType) => void): any =>
  async (dispatch: Dispatch<Action>, getState: typeof rootReducer) => {
    try {
      const {
        auth: { user },
      } = getState();
      const result = (await AxiosReq.get(`/api/Account/CheckToken/${token}`, user.userToken)) as APIResponseType;
      cb(result);
    } catch (error: any) {
      cb(error);
    }
  };
